enum LoanDrawdownStatusEnum {
    Approved = 'APPROVED',
    DisbursalInstructed = 'DISBURSAL_INSTRUCTED',
    PendingApproval = 'PENDING_APPROVAL',
    Processed = 'PROCESSED',
    QsInstructed = 'QS_INSTRUCTED',
    QsReceived = 'QS_RECEIVED',
    Requested = 'REQUESTED',
}

export default LoanDrawdownStatusEnum;
